var _g, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 533.4 762.3",
    style: {
      enableBackground: "new 0 0 533.4 762.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M266.7,296.3C119.4,296.3,0,400.6,0,529.3s119.4,233,266.7,233s266.7-104.3,266.7-233S414,296.3,266.7,296.3z M266.7,718.1 c-119.1,0-215.6-84.3-215.6-188.3c0-104,97.6-151.7,216.6-151.7s214.6,47.7,214.6,151.7C482.3,633.8,385.8,718.1,266.7,718.1z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 268.7,
    cy: 148.2,
    r: 148.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.45599045802bb8273f4fcb49f5ea02ae.svg";
export { ForwardRef as ReactComponent };